import { render, staticRenderFns } from "./PaymentResult.vue?vue&type=template&id=0614b5eb&lang=pug&"
import script from "./PaymentResult.vue?vue&type=script&lang=ts&"
export * from "./PaymentResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports